import Header from 'components/header';
import React from 'react'
import { useNavigate } from 'react-router-dom';
import { Container, Icon } from 'semantic-ui-react';
import CardsShowcase from './CardsShowcase';

import StagesShowcase from './StagesShowcase';

const Compendium = () => {
    const navigate = useNavigate();
    return (
        <div className="melee-wrapper">
            <Container className='regularText' style={{ paddingTop: 10, paddingBottom: 10 }}>
                <Header
                    helmet='Compendium'
                    rightMenu={
                        <button
                            className="melee-inline-button"
                            onClick={() => navigate(-1)}
                        >
                            Back
                        </button>}
                />
                <div className='page-header'>
                    <h1><Icon name='book' />Compendium</h1>
                </div>
                <div style={{ marginBottom: 32 }}>
                    <CardsShowcase />
                </div>
                <div style={{ marginBottom: 32 }}>
                    <StagesShowcase />
                </div>
            </Container>
        </div>
    )
}

export default Compendium;